export type KVCameraPoseJSON = {
  imageId: string
  x: number
  y: number
  z: number
  heading: number
  pitch: number
  roll: number
}

export class KVCameraPose {
  imageId: string
  x: number
  y: number
  z: number
  heading: number
  pitch: number
  roll: number

  constructor(
    imageId: string,
    x: number,
    y: number,
    z: number,
    heading: number,
    pitch: number,
    roll: number
  ) {
    this.imageId = imageId
    this.x = x
    this.y = y
    this.z = z
    this.heading = heading
    this.pitch = pitch
    this.roll = roll
  }

  static toJSON(position: KVCameraPose): KVCameraPoseJSON {
    return {
      imageId: position.imageId,
      x: position.x,
      y: position.y,
      z: position.z,
      heading: position.heading,
      pitch: position.pitch,
      roll: position.roll,
    }
  }
}
